import {useState, React} from 'react';
import { Typography, Row, Col, Card, Button, Checkbox, Divider} from 'antd';
//import { Amplify } from 'aws-amplify';
import { signInWithRedirect } from "aws-amplify/auth";

function Authentication() {

  const [eulaNotAccepted, setEulaNotAccepted] = useState(false);

  const handleStartAuth = async () => {
    try {
      await signInWithRedirect({ provider: 'Asana' });
    } catch (error) {
      console.error('Error starting authentication:', error);
    }
  };

  const handleEulaCheckboxChange = (e) => {
    setEulaNotAccepted(e.target.checked);
  };

  return (
    <Row justify={"center"}>
      <Col span={10}>
        <br />
        <Card title="App Authentication">
          <Typography.Title level={2}>Attachment Manager for Asana</Typography.Title>
          <Typography.Paragraph>Click the button below to authenticate with Asana:</Typography.Paragraph>
          <Checkbox onChange={handleEulaCheckboxChange}>I agree with <a target='_blank' rel="noopener noreferrer" href="https://www.bdq.cloud/legal/eula">EULA</a></Checkbox>
          <Divider />
          <Button size="large" type="primary" disabled={!eulaNotAccepted} onClick={handleStartAuth}>Authenticate with Asana</Button>
        </Card>
      </Col>
    </Row>
  );
}

export default Authentication;